import { render, staticRenderFns } from "./CourtDialog.vue?vue&type=template&id=a1b6950e&scoped=true"
import script from "./CourtDialog.vue?vue&type=script&lang=js"
export * from "./CourtDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=a1b6950e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b6950e",
  null
  
)

export default component.exports